"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feedback = Feedback;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Announcer = require("./Announcer");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var DottedText = (0, _styledComponents["default"])(_grommet.Text)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  text-decoration-style: dotted;\n"])));
var isPromise = function isPromise(v) {
  return _typeof(v) === 'object' && typeof v.then === 'function';
};
function Feedback(_ref) {
  var onFeedback = _ref.onFeedback;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    rating = _useState2[0],
    setRating = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitted = _useState4[0],
    setSubmitted = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var onSubmit = function onSubmit(_ref2) {
    var value = _ref2.value;
    var result = onFeedback(value);
    if (isPromise(result)) {
      result.then(function /* response */
      () {
        setRating(null);
        setSubmitted(true);
        setError(false);
      }, function /* reason */
      () {
        setError(true);
      })["catch"](function /* e */
      () {
        setError(true);
      });
    } else {
      setRating(null);
      setError(false);
      setSubmitted(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
    pad: {
      top: 'medium'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Form, {
      onSubmit: onSubmit,
      onChange: function onChange() {
        return setSubmitted(false);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
        direction: "row",
        gap: "medium",
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Text, {
          weight: 500,
          children: t('feedback_rating_lbl')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.ThumbsRating, {
          name: "rating",
          value: rating,
          onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return setRating(value);
          }
        })]
      }), rating && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
        gap: "small",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.FormField, {
          htmlFor: "feedback-why",
          name: "why",
          label: t('feedback_why_lbl'),
          placeholder: rating === 'like' ? t('feedback_like_placeholder') : t('feedback_dislike_placeholder')
        }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Box, {
          pad: {
            bottom: 'small'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Announcer.Announcer, {
            message: "Unable to submit feedback"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Button, {
          primary: true,
          type: "submit",
          alignSelf: "end",
          label: t('feedback_submit_lbl')
        })]
      })]
    }), submitted && /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Box, {
      pad: {
        bottom: 'small'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Announcer.Announcer, {
        message: t('feedback_submitted')
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DottedText, {
      tip: {
        content: t('feedback_usage_tip'),
        dropProps: {
          dropAlign: {
            bottom: 'top'
          }
        }
      },
      weight: 500,
      size: "xsmall",
      color: "text",
      children: t('feedback_usage_lnk')
    })]
  });
}
Feedback.propTypes = {
  onFeedback: _propTypes["default"].func.isRequired
};